// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d5-3";
export var flatBottomCorners = "_d5-5";
export var productImage = "_d5-0";
export var quantityContainer = "_d5-2";
export var quantityHeader = "_d5-6";
export var tooltip = "_d5-1";
export var wrapAndEllipsesOverflow = "_d5-4";